export default {"src":"/_next/static/media/coins-right.691e1e15.svg","height":190,"width":123,"blurWidth":0,"blurHeight":0};